/* @sravni/react-design-system version 0.2.71 */
var css = "._1qi8xjy {\n  width: 100%;\n  max-width: 1320px;\n  margin: 0 auto;\n  padding: 0 16px;\n}\n@media screen and (min-width: 768px) {\n  ._1qi8xjy {\n    padding: 0 30px;\n  }\n}\n";
var modules_e182d482 = {"container":"_1qi8xjy"};
import "../../../assets/components/Layout/src/Layout-617b02e0.css";

export default modules_e182d482;
export { css };
